module.exports = __webpack_public_path__ + "static/media/ktm-13.3cae528a.png";